import { render, staticRenderFns } from "./ProtocolPack.vue?vue&type=template&id=775afb05"
import script from "./ProtocolPack.vue?vue&type=script&lang=js"
export * from "./ProtocolPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports